import { render, staticRenderFns } from "./RentalProductDetails.vue?vue&type=template&id=60139124&scoped=true&"
import script from "./RentalProductDetails.vue?vue&type=script&lang=ts&"
export * from "./RentalProductDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60139124",
  null
  
)

export default component.exports